// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdp {
    --rdp-cell-size: 56px;
    --rdp-accent-color: #151514;
    --rdp-background-color: #e7edff;
    --rdp-accent-color-dark: #3003e1;
    --rdp-background-color-dark: #180270;
    --rdp-outline: 2px solid var(--rdp-accent-color);
    /* Outline border for focused elements */
    --rdp-outline-selected: 3px solid var(--rdp-accent-color);
    /* Outline border for focused _and_ selected elements */

    /* margin: 1em; */
    background-color: #fefefe;
    border-radius: 8px;
    padding: 32px 38px;
    font-family: 'Inter';
}

/* Hide elements for devices that are not screen readers */
.rdp-vhidden {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    background: transparent;
    border: 0;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    position: absolute !important;
    top: 0;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    overflow: hidden !important;
    clip: rect(1px, 1px, 1px, 1px) !important;
    border: 0 !important;
}

/* Buttons */
.rdp-button_reset {
    appearance: none;
    position: relative;
    margin: 0;
    padding: 0;
    cursor: default;
    color: inherit;
    background: none;
    font: inherit;

    -moz-appearance: none;
    -webkit-appearance: none;
}

.rdp-button_reset:focus-visible {
    /* Make sure to reset outline only when :focus-visible is supported */
    outline: none;
}

.rdp-button {
    border: none;
}

.rdp-button[disabled] {
    opacity: 0.25;
}

.rdp-button:not([disabled]) {
    cursor: pointer;
}

.rdp-button:focus-visible:not([disabled]),
.rdp-button:active:not([disabled]) {
    color: inherit;
    background-color: var(--rdp-background-color);
    /* border: var(--rdp-outline); */
}

.card-cell button:hover:not([disabled]) {
    background-color: #E7E7E7;
}

.rdp-months {
    display: flex;
}

.rdp-month {
    margin: 0 1em;
}

.rdp-month:first-child {
    margin-left: 0;
}

.rdp-month:last-child {
    margin-right: 0;
}

.rdp-table {
    margin: 0;
    max-width: calc(var(--rdp-cell-size) * 7);
    border-collapse: collapse;
    /* border-spacing: 10px 10px; */
}

.rdp-with_weeknumber .rdp-table {
    max-width: calc(var(--rdp-cell-size) * 8);
    border-collapse: collapse;
}

.rdp-caption {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    text-align: left;
    margin-bottom: 30px;
}

.rdp-multiple_months .rdp-caption {
    position: relative;
    display: block;
    text-align: center;
}

.rdp-caption_dropdowns {
    position: relative;
    display: inline-flex;
}

.rdp-caption_label {
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    margin: 0;
    padding: 0 0 0 10px;
    white-space: nowrap;
    color: #909090;
    border: 0;
    border: 2px solid transparent;
    font-family: inherit;
    font-weight: bold;
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
}

.rdp-nav {
    white-space: nowrap;
    color: #909090;
}

.rdp-multiple_months .rdp-caption_start .rdp-nav {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
}

.rdp-multiple_months .rdp-caption_end .rdp-nav {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
}

.rdp-nav_button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0.25em;
    border-radius: 100%;
}

/* ---------- */
/* Dropdowns  */
/* ---------- */

.rdp-dropdown_year,
.rdp-dropdown_month {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.rdp-dropdown {
    appearance: none;
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    cursor: inherit;
    opacity: 0;
    border: none;
    background-color: transparent;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}

.rdp-dropdown[disabled] {
    opacity: unset;
    color: unset;
}

.rdp-dropdown:focus-visible:not([disabled])+.rdp-caption_label,
.rdp-dropdown:active:not([disabled])+.rdp-caption_label {
    background-color: var(--rdp-background-color);
    border: var(--rdp-outline);
    border-radius: 6px;
}

.rdp-dropdown_icon {
    margin: 0 0 0 5px;
}

.rdp-head {
    border: 0;
}

.rdp-head_row,
.rdp-row {
    height: 100%;
    display: grid;
    grid-template-columns: repeat(7, var(--rdp-cell-size));
    column-gap: 16px;
}

.rdp-head_cell {
    vertical-align: middle;
    text-transform: uppercase;
    /* font-size: 0.75em; */
    text-align: center;
    height: 100%;
    height: var(--rdp-cell-size);
    padding: 0;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.02em;
    color: #909090;
}

.rdp-tbody {
    border: 0;
    display: grid;
    grid-template-columns: 100%;
    row-gap: 10px;
}

.rdp-tfoot {
    margin: 0.5em;
}

.rdp-cell {
    width: var(--rdp-cell-size);
    height: 100%;
    height: var(--rdp-cell-size);
    padding: 0;
    text-align: center;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 40px;
    color: #909090;
}

.rdp-weeknumber {
    font-size: 0.75em;
}

.rdp-weeknumber,
.rdp-day {
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: var(--rdp-cell-size);
    max-width: var(--rdp-cell-size);
    height: var(--rdp-cell-size);
    margin: 0;
    /* border: 2px solid transparent; */
    border-radius: 3px;
    font-weight: 400;
}

.rdp-day_selected:not([disabled]),
.rdp-day_selected:focus:not([disabled]),
.rdp-day_selected:active:not([disabled]),
.rdp-day_selected:hover:not([disabled]) {
    color: white;
    background-color: var(--rdp-accent-color);
}

.rdp-day_selected:focus:not([disabled]) {
    /* Since the background is the same use again the outline */
    /* outline: var(--rdp-outline); */
    /* outline-offset: 2px; */
    z-index: 1;
}

.rdp:not([dir='rtl']) .rdp-day_range_start:not(.rdp-day_range_end) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.rdp:not([dir='rtl']) .rdp-day_range_end:not(.rdp-day_range_start) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.rdp[dir='rtl'] .rdp-day_range_start:not(.rdp-day_range_end) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.rdp[dir='rtl'] .rdp-day_range_end:not(.rdp-day_range_start) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.rdp-day_range_end.rdp-day_range_start {
    border-radius: 100%;
}

.rdp-day_range_middle {
    border-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./src/shared/modals/scheduleModal/CalendarComponent/styles.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,+BAA+B;IAC/B,gCAAgC;IAChC,oCAAoC;IACpC,gDAAgD;IAChD,wCAAwC;IACxC,yDAAyD;IACzD,uDAAuD;;IAEvD,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,0DAA0D;AAC1D;IACI,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,SAAS;IACT,qBAAqB;IACrB,wBAAwB;IACxB,gBAAgB;IAChB,6BAA6B;IAC7B,MAAM;IACN,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,2BAA2B;IAC3B,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA,YAAY;AACZ;IACI,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;;IAEb,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,qEAAqE;IACrE,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,cAAc;IACd,6CAA6C;IAC7C,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,yCAAyC;IACzC,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,6BAA6B;IAC7B,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA,eAAe;AACf,eAAe;AACf,eAAe;;AAEf;;IAEI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,OAAO;IACP,WAAW;IACX,SAAS;IACT,UAAU;IACV,eAAe;IACf,UAAU;IACV,YAAY;IACZ,6BAA6B;IAC7B,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,6CAA6C;IAC7C,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,sDAAsD;IACtD,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,4BAA4B;IAC5B,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B,+BAA+B;IAC/B,4BAA4B;IAC5B,SAAS;IACT,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;;;IAII,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,2DAA2D;IAC3D,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".rdp {\n    --rdp-cell-size: 56px;\n    --rdp-accent-color: #151514;\n    --rdp-background-color: #e7edff;\n    --rdp-accent-color-dark: #3003e1;\n    --rdp-background-color-dark: #180270;\n    --rdp-outline: 2px solid var(--rdp-accent-color);\n    /* Outline border for focused elements */\n    --rdp-outline-selected: 3px solid var(--rdp-accent-color);\n    /* Outline border for focused _and_ selected elements */\n\n    /* margin: 1em; */\n    background-color: #fefefe;\n    border-radius: 8px;\n    padding: 32px 38px;\n    font-family: 'Inter';\n}\n\n/* Hide elements for devices that are not screen readers */\n.rdp-vhidden {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n    background: transparent;\n    border: 0;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    appearance: none;\n    position: absolute !important;\n    top: 0;\n    width: 1px !important;\n    height: 1px !important;\n    padding: 0 !important;\n    overflow: hidden !important;\n    clip: rect(1px, 1px, 1px, 1px) !important;\n    border: 0 !important;\n}\n\n/* Buttons */\n.rdp-button_reset {\n    appearance: none;\n    position: relative;\n    margin: 0;\n    padding: 0;\n    cursor: default;\n    color: inherit;\n    background: none;\n    font: inherit;\n\n    -moz-appearance: none;\n    -webkit-appearance: none;\n}\n\n.rdp-button_reset:focus-visible {\n    /* Make sure to reset outline only when :focus-visible is supported */\n    outline: none;\n}\n\n.rdp-button {\n    border: none;\n}\n\n.rdp-button[disabled] {\n    opacity: 0.25;\n}\n\n.rdp-button:not([disabled]) {\n    cursor: pointer;\n}\n\n.rdp-button:focus-visible:not([disabled]),\n.rdp-button:active:not([disabled]) {\n    color: inherit;\n    background-color: var(--rdp-background-color);\n    /* border: var(--rdp-outline); */\n}\n\n.card-cell button:hover:not([disabled]) {\n    background-color: #E7E7E7;\n}\n\n.rdp-months {\n    display: flex;\n}\n\n.rdp-month {\n    margin: 0 1em;\n}\n\n.rdp-month:first-child {\n    margin-left: 0;\n}\n\n.rdp-month:last-child {\n    margin-right: 0;\n}\n\n.rdp-table {\n    margin: 0;\n    max-width: calc(var(--rdp-cell-size) * 7);\n    border-collapse: collapse;\n    /* border-spacing: 10px 10px; */\n}\n\n.rdp-with_weeknumber .rdp-table {\n    max-width: calc(var(--rdp-cell-size) * 8);\n    border-collapse: collapse;\n}\n\n.rdp-caption {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0;\n    text-align: left;\n    margin-bottom: 30px;\n}\n\n.rdp-multiple_months .rdp-caption {\n    position: relative;\n    display: block;\n    text-align: center;\n}\n\n.rdp-caption_dropdowns {\n    position: relative;\n    display: inline-flex;\n}\n\n.rdp-caption_label {\n    position: relative;\n    z-index: 1;\n    display: inline-flex;\n    align-items: center;\n    margin: 0;\n    padding: 0 0 0 10px;\n    white-space: nowrap;\n    color: #909090;\n    border: 0;\n    border: 2px solid transparent;\n    font-family: inherit;\n    font-weight: bold;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 30px;\n    line-height: 40px;\n}\n\n.rdp-nav {\n    white-space: nowrap;\n    color: #909090;\n}\n\n.rdp-multiple_months .rdp-caption_start .rdp-nav {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n}\n\n.rdp-multiple_months .rdp-caption_end .rdp-nav {\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n}\n\n.rdp-nav_button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    padding: 0.25em;\n    border-radius: 100%;\n}\n\n/* ---------- */\n/* Dropdowns  */\n/* ---------- */\n\n.rdp-dropdown_year,\n.rdp-dropdown_month {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n}\n\n.rdp-dropdown {\n    appearance: none;\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    cursor: inherit;\n    opacity: 0;\n    border: none;\n    background-color: transparent;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n}\n\n.rdp-dropdown[disabled] {\n    opacity: unset;\n    color: unset;\n}\n\n.rdp-dropdown:focus-visible:not([disabled])+.rdp-caption_label,\n.rdp-dropdown:active:not([disabled])+.rdp-caption_label {\n    background-color: var(--rdp-background-color);\n    border: var(--rdp-outline);\n    border-radius: 6px;\n}\n\n.rdp-dropdown_icon {\n    margin: 0 0 0 5px;\n}\n\n.rdp-head {\n    border: 0;\n}\n\n.rdp-head_row,\n.rdp-row {\n    height: 100%;\n    display: grid;\n    grid-template-columns: repeat(7, var(--rdp-cell-size));\n    column-gap: 16px;\n}\n\n.rdp-head_cell {\n    vertical-align: middle;\n    text-transform: uppercase;\n    /* font-size: 0.75em; */\n    text-align: center;\n    height: 100%;\n    height: var(--rdp-cell-size);\n    padding: 0;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 30px;\n    line-height: 40px;\n    letter-spacing: -0.02em;\n    color: #909090;\n}\n\n.rdp-tbody {\n    border: 0;\n    display: grid;\n    grid-template-columns: 100%;\n    row-gap: 10px;\n}\n\n.rdp-tfoot {\n    margin: 0.5em;\n}\n\n.rdp-cell {\n    width: var(--rdp-cell-size);\n    height: 100%;\n    height: var(--rdp-cell-size);\n    padding: 0;\n    text-align: center;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 30px;\n    line-height: 40px;\n    color: #909090;\n}\n\n.rdp-weeknumber {\n    font-size: 0.75em;\n}\n\n.rdp-weeknumber,\n.rdp-day {\n    display: flex;\n    overflow: hidden;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    width: var(--rdp-cell-size);\n    max-width: var(--rdp-cell-size);\n    height: var(--rdp-cell-size);\n    margin: 0;\n    /* border: 2px solid transparent; */\n    border-radius: 3px;\n    font-weight: 400;\n}\n\n.rdp-day_selected:not([disabled]),\n.rdp-day_selected:focus:not([disabled]),\n.rdp-day_selected:active:not([disabled]),\n.rdp-day_selected:hover:not([disabled]) {\n    color: white;\n    background-color: var(--rdp-accent-color);\n}\n\n.rdp-day_selected:focus:not([disabled]) {\n    /* Since the background is the same use again the outline */\n    /* outline: var(--rdp-outline); */\n    /* outline-offset: 2px; */\n    z-index: 1;\n}\n\n.rdp:not([dir='rtl']) .rdp-day_range_start:not(.rdp-day_range_end) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.rdp:not([dir='rtl']) .rdp-day_range_end:not(.rdp-day_range_start) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.rdp[dir='rtl'] .rdp-day_range_start:not(.rdp-day_range_end) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.rdp[dir='rtl'] .rdp-day_range_end:not(.rdp-day_range_start) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.rdp-day_range_end.rdp-day_range_start {\n    border-radius: 100%;\n}\n\n.rdp-day_range_middle {\n    border-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdp {
    --rdp-cell-size: 56px;
    --rdp-accent-color: #151514;
    --rdp-background-color: #e7edff;
    --rdp-accent-color-dark: #3003e1;
    --rdp-background-color-dark: #180270;
    --rdp-outline: 2px solid var(--rdp-accent-color);
    /* Outline border for focused elements */
    --rdp-outline-selected: 3px solid var(--rdp-accent-color);
    /* Outline border for focused _and_ selected elements */

    /* margin: 1em; */
    background-color: #fefefe;
    border-radius: 8px;
    padding: 32px 38px;
    font-family: 'Inter';
}

/* Hide elements for devices that are not screen readers */
.rdp-vhidden {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    background: transparent;
    border: 0;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    position: absolute !important;
    top: 0;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    overflow: hidden !important;
    clip: rect(1px, 1px, 1px, 1px) !important;
    border: 0 !important;
}

/* Buttons */
.rdp-button_reset {
    appearance: none;
    position: relative;
    margin: 0;
    padding: 0;
    cursor: default;
    color: inherit;
    background: none;
    font: inherit;

    -moz-appearance: none;
    -webkit-appearance: none;
}

.rdp-button_reset:focus-visible {
    /* Make sure to reset outline only when :focus-visible is supported */
    outline: none;
}

.rdp-button {
    border: none;
}

.rdp-button[disabled] {
    opacity: 0.25;
}

.rdp-button:not([disabled]) {
    cursor: pointer;
}

.rdp-button:focus-visible:not([disabled]),
.rdp-button:active:not([disabled]) {
    color: inherit;
    background-color: var(--rdp-background-color);
    /* border: var(--rdp-outline); */
}

.card-cell button:hover:not([disabled]) {
    background-color: #E7E7E7;
}

.rdp-months {
    display: flex;
}

.rdp-month {
    margin: 0 1em;
}

.rdp-month:first-child {
    margin-left: 0;
}

.rdp-month:last-child {
    margin-right: 0;
}

.rdp-table {
    margin: 0;
    max-width: calc(var(--rdp-cell-size) * 7);
    border-collapse: collapse;
    /* border-spacing: 10px 10px; */
}

.rdp-with_weeknumber .rdp-table {
    max-width: calc(var(--rdp-cell-size) * 8);
    border-collapse: collapse;
}

.rdp-caption {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    text-align: left;
    margin-bottom: 30px;
}

.rdp-multiple_months .rdp-caption {
    position: relative;
    display: block;
    text-align: center;
}

.rdp-caption_dropdowns {
    position: relative;
    display: inline-flex;
}

.rdp-caption_label {
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    margin: 0;
    padding: 0 0 0 10px;
    white-space: nowrap;
    color: #909090;
    border: 0;
    border: 2px solid transparent;
    font-family: inherit;
    font-weight: bold;
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
}

.rdp-nav {
    white-space: nowrap;
    color: #909090;
}

.rdp-multiple_months .rdp-caption_start .rdp-nav {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
}

.rdp-multiple_months .rdp-caption_end .rdp-nav {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
}

.rdp-nav_button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0.25em;
    border-radius: 100%;
}

/* ---------- */
/* Dropdowns  */
/* ---------- */

.rdp-dropdown_year,
.rdp-dropdown_month {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.rdp-dropdown {
    appearance: none;
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    cursor: inherit;
    opacity: 0;
    border: none;
    background-color: transparent;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}

.rdp-dropdown[disabled] {
    opacity: unset;
    color: unset;
}

.rdp-dropdown:focus-visible:not([disabled])+.rdp-caption_label,
.rdp-dropdown:active:not([disabled])+.rdp-caption_label {
    background-color: var(--rdp-background-color);
    border: var(--rdp-outline);
    border-radius: 6px;
}

.rdp-dropdown_icon {
    margin: 0 0 0 5px;
}

.rdp-head {
    border: 0;
}

.rdp-head_row,
.rdp-row {
    height: 100%;
    display: grid;
    grid-template-columns: repeat(7, var(--rdp-cell-size));
    column-gap: 16px;
}

.rdp-head_cell {
    vertical-align: middle;
    text-transform: uppercase;
    /* font-size: 0.75em; */
    text-align: center;
    height: 100%;
    height: var(--rdp-cell-size);
    padding: 0;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.02em;
    color: #909090;
}

.rdp-tbody {
    border: 0;
    display: grid;
    grid-template-columns: 100%;
    row-gap: 10px;
}

.rdp-tfoot {
    margin: 0.5em;
}

.rdp-cell {
    width: var(--rdp-cell-size);
    height: 100%;
    height: var(--rdp-cell-size);
    padding: 0;
    text-align: center;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 40px;
    color: #909090;
}

.rdp-weeknumber {
    font-size: 0.75em;
}

.rdp-weeknumber,
.rdp-day {
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: var(--rdp-cell-size);
    max-width: var(--rdp-cell-size);
    height: var(--rdp-cell-size);
    margin: 0;
    /* border: 2px solid transparent; */
    border-radius: 3px;
    font-weight: 400;
}

.rdp-day_selected:not([disabled]),
.rdp-day_selected:focus:not([disabled]),
.rdp-day_selected:active:not([disabled]),
.rdp-day_selected:hover:not([disabled]) {
    color: white;
    background-color: var(--rdp-accent-color);
}

.rdp-day_selected:focus:not([disabled]) {
    /* Since the background is the same use again the outline */
    /* outline: var(--rdp-outline); */
    /* outline-offset: 2px; */
    z-index: 1;
}

.rdp:not([dir='rtl']) .rdp-day_range_start:not(.rdp-day_range_end) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.rdp:not([dir='rtl']) .rdp-day_range_end:not(.rdp-day_range_start) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.rdp[dir='rtl'] .rdp-day_range_start:not(.rdp-day_range_end) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.rdp[dir='rtl'] .rdp-day_range_end:not(.rdp-day_range_start) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.rdp-day_range_end.rdp-day_range_start {
    border-radius: 100%;
}

.rdp-day_range_middle {
    border-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./src/shared/modals/scheduleModal/CalendarComponent/styles.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,+BAA+B;IAC/B,gCAAgC;IAChC,oCAAoC;IACpC,gDAAgD;IAChD,wCAAwC;IACxC,yDAAyD;IACzD,uDAAuD;;IAEvD,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,0DAA0D;AAC1D;IACI,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,SAAS;IACT,qBAAqB;IACrB,wBAAwB;IACxB,gBAAgB;IAChB,6BAA6B;IAC7B,MAAM;IACN,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,2BAA2B;IAC3B,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA,YAAY;AACZ;IACI,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;;IAEb,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,qEAAqE;IACrE,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,cAAc;IACd,6CAA6C;IAC7C,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,yCAAyC;IACzC,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,6BAA6B;IAC7B,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA,eAAe;AACf,eAAe;AACf,eAAe;;AAEf;;IAEI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,OAAO;IACP,WAAW;IACX,SAAS;IACT,UAAU;IACV,eAAe;IACf,UAAU;IACV,YAAY;IACZ,6BAA6B;IAC7B,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,6CAA6C;IAC7C,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,sDAAsD;IACtD,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,4BAA4B;IAC5B,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B,+BAA+B;IAC/B,4BAA4B;IAC5B,SAAS;IACT,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;;;IAII,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,2DAA2D;IAC3D,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".rdp {\n    --rdp-cell-size: 56px;\n    --rdp-accent-color: #151514;\n    --rdp-background-color: #e7edff;\n    --rdp-accent-color-dark: #3003e1;\n    --rdp-background-color-dark: #180270;\n    --rdp-outline: 2px solid var(--rdp-accent-color);\n    /* Outline border for focused elements */\n    --rdp-outline-selected: 3px solid var(--rdp-accent-color);\n    /* Outline border for focused _and_ selected elements */\n\n    /* margin: 1em; */\n    background-color: #fefefe;\n    border-radius: 8px;\n    padding: 32px 38px;\n    font-family: 'Inter';\n}\n\n/* Hide elements for devices that are not screen readers */\n.rdp-vhidden {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n    background: transparent;\n    border: 0;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    appearance: none;\n    position: absolute !important;\n    top: 0;\n    width: 1px !important;\n    height: 1px !important;\n    padding: 0 !important;\n    overflow: hidden !important;\n    clip: rect(1px, 1px, 1px, 1px) !important;\n    border: 0 !important;\n}\n\n/* Buttons */\n.rdp-button_reset {\n    appearance: none;\n    position: relative;\n    margin: 0;\n    padding: 0;\n    cursor: default;\n    color: inherit;\n    background: none;\n    font: inherit;\n\n    -moz-appearance: none;\n    -webkit-appearance: none;\n}\n\n.rdp-button_reset:focus-visible {\n    /* Make sure to reset outline only when :focus-visible is supported */\n    outline: none;\n}\n\n.rdp-button {\n    border: none;\n}\n\n.rdp-button[disabled] {\n    opacity: 0.25;\n}\n\n.rdp-button:not([disabled]) {\n    cursor: pointer;\n}\n\n.rdp-button:focus-visible:not([disabled]),\n.rdp-button:active:not([disabled]) {\n    color: inherit;\n    background-color: var(--rdp-background-color);\n    /* border: var(--rdp-outline); */\n}\n\n.card-cell button:hover:not([disabled]) {\n    background-color: #E7E7E7;\n}\n\n.rdp-months {\n    display: flex;\n}\n\n.rdp-month {\n    margin: 0 1em;\n}\n\n.rdp-month:first-child {\n    margin-left: 0;\n}\n\n.rdp-month:last-child {\n    margin-right: 0;\n}\n\n.rdp-table {\n    margin: 0;\n    max-width: calc(var(--rdp-cell-size) * 7);\n    border-collapse: collapse;\n    /* border-spacing: 10px 10px; */\n}\n\n.rdp-with_weeknumber .rdp-table {\n    max-width: calc(var(--rdp-cell-size) * 8);\n    border-collapse: collapse;\n}\n\n.rdp-caption {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0;\n    text-align: left;\n    margin-bottom: 30px;\n}\n\n.rdp-multiple_months .rdp-caption {\n    position: relative;\n    display: block;\n    text-align: center;\n}\n\n.rdp-caption_dropdowns {\n    position: relative;\n    display: inline-flex;\n}\n\n.rdp-caption_label {\n    position: relative;\n    z-index: 1;\n    display: inline-flex;\n    align-items: center;\n    margin: 0;\n    padding: 0 0 0 10px;\n    white-space: nowrap;\n    color: #909090;\n    border: 0;\n    border: 2px solid transparent;\n    font-family: inherit;\n    font-weight: bold;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 30px;\n    line-height: 40px;\n}\n\n.rdp-nav {\n    white-space: nowrap;\n    color: #909090;\n}\n\n.rdp-multiple_months .rdp-caption_start .rdp-nav {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n}\n\n.rdp-multiple_months .rdp-caption_end .rdp-nav {\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n}\n\n.rdp-nav_button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    padding: 0.25em;\n    border-radius: 100%;\n}\n\n/* ---------- */\n/* Dropdowns  */\n/* ---------- */\n\n.rdp-dropdown_year,\n.rdp-dropdown_month {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n}\n\n.rdp-dropdown {\n    appearance: none;\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    cursor: inherit;\n    opacity: 0;\n    border: none;\n    background-color: transparent;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n}\n\n.rdp-dropdown[disabled] {\n    opacity: unset;\n    color: unset;\n}\n\n.rdp-dropdown:focus-visible:not([disabled])+.rdp-caption_label,\n.rdp-dropdown:active:not([disabled])+.rdp-caption_label {\n    background-color: var(--rdp-background-color);\n    border: var(--rdp-outline);\n    border-radius: 6px;\n}\n\n.rdp-dropdown_icon {\n    margin: 0 0 0 5px;\n}\n\n.rdp-head {\n    border: 0;\n}\n\n.rdp-head_row,\n.rdp-row {\n    height: 100%;\n    display: grid;\n    grid-template-columns: repeat(7, var(--rdp-cell-size));\n    column-gap: 16px;\n}\n\n.rdp-head_cell {\n    vertical-align: middle;\n    text-transform: uppercase;\n    /* font-size: 0.75em; */\n    text-align: center;\n    height: 100%;\n    height: var(--rdp-cell-size);\n    padding: 0;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 30px;\n    line-height: 40px;\n    letter-spacing: -0.02em;\n    color: #909090;\n}\n\n.rdp-tbody {\n    border: 0;\n    display: grid;\n    grid-template-columns: 100%;\n    row-gap: 10px;\n}\n\n.rdp-tfoot {\n    margin: 0.5em;\n}\n\n.rdp-cell {\n    width: var(--rdp-cell-size);\n    height: 100%;\n    height: var(--rdp-cell-size);\n    padding: 0;\n    text-align: center;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 30px;\n    line-height: 40px;\n    color: #909090;\n}\n\n.rdp-weeknumber {\n    font-size: 0.75em;\n}\n\n.rdp-weeknumber,\n.rdp-day {\n    display: flex;\n    overflow: hidden;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    width: var(--rdp-cell-size);\n    max-width: var(--rdp-cell-size);\n    height: var(--rdp-cell-size);\n    margin: 0;\n    /* border: 2px solid transparent; */\n    border-radius: 3px;\n    font-weight: 400;\n}\n\n.rdp-day_selected:not([disabled]),\n.rdp-day_selected:focus:not([disabled]),\n.rdp-day_selected:active:not([disabled]),\n.rdp-day_selected:hover:not([disabled]) {\n    color: white;\n    background-color: var(--rdp-accent-color);\n}\n\n.rdp-day_selected:focus:not([disabled]) {\n    /* Since the background is the same use again the outline */\n    /* outline: var(--rdp-outline); */\n    /* outline-offset: 2px; */\n    z-index: 1;\n}\n\n.rdp:not([dir='rtl']) .rdp-day_range_start:not(.rdp-day_range_end) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.rdp:not([dir='rtl']) .rdp-day_range_end:not(.rdp-day_range_start) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.rdp[dir='rtl'] .rdp-day_range_start:not(.rdp-day_range_end) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.rdp[dir='rtl'] .rdp-day_range_end:not(.rdp-day_range_start) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.rdp-day_range_end.rdp-day_range_start {\n    border-radius: 100%;\n}\n\n.rdp-day_range_middle {\n    border-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
